import imageCompression from 'browser-image-compression';

export const handleExcludedFields = (obj, excludedFields) => {
    const asArray = Object.entries(obj);

    const filtered = asArray.filter(([key, _]) => !excludedFields.includes(key));

    const includedFields = Object.fromEntries(filtered);
    return includedFields;
};

export const fileToBase64 = async (file, callback) => {
    const fileName = file.name
    const fileType = file.type

    const reader = new FileReader();
    const options = {
        maxSizeMB: 0.200,
        useWebWorker: true,
    } 

    if (file.size > 200000) {
        file = await imageCompression(file, options);
    }

    reader.readAsDataURL(file);
    
    reader.onloadend = () => {
        return callback({fileName, fileType, fileContent: reader.result})
    }
}